import { Callout } from "@blueprintjs/core";
import _ from "lodash";
import { inspect } from "util";
import { UserLanguage } from "../../lang/lang";
import { BackendError } from "../Error";

export const ErrorCard = (props: { error?: BackendError | null }) => {
  if (props.error === null || props.error === undefined) return <></>;

  const e = props.error;

  console.log("got error", props.error);
  let message = `no handler for this error defined ${inspect(
    e,
    false,
    2,
    true
  )}`;

  switch (e.type) {
    case "schema.unique": {
      console.log("keys", e.keys);
      message = UserLanguage().errors.schema.unique(e.keys!, e.model!);
      break;
    }
    default: {
      message = _.get(UserLanguage().errors, e.type, e.type);
    }
  }

  return (
    <Callout intent="danger" style={{ marginBottom: 20 }}>
      {message}
    </Callout>
  );
};
